<script>
  import { AppStore } from '../stores/AppStore'
  import SliderWithLabels from './SliderWithLabels.svelte'

  let durationString = ""
  $: {
    if ($AppStore.podcasts) {
      let duration = $AppStore.podcasts[$AppStore.state.activePodcastID].playlists[$AppStore.state.durationIndex].duration
      let mins = parseInt(duration / 60, 10)
      let secs = duration % 60
      durationString = `${mins}mins ${secs}s`
    }
  }
</script>

<div class="w-full flex flex-col my-4 sm:my-12">
  <div class="flex justify-between">
    <span class="font-bold text-blue-700">Podcast Length</span>
    <span class="font-lighter text-gray-700">{durationString}</span>
  </div>
  <div class="w-full flex-1 mt-4">
    <SliderWithLabels
      labels={["shortest", "shorter", "longer", "longest", "full"]}
    />
  </div>
</div>